import React, { Component } from 'react';
import styled from 'styled-components';

import mediaWidth from '../../../utils/mediaWidth/mediaWidth';

import logo from './assets/logo-big.svg';

import getHideAnimation from './hideAnimation';

const hideAnimation = getHideAnimation();

export default class StartLogo extends Component {
    render() {
        const {
            className,
            offsetLeft,
            offsetTop,
            isShow,
            isHide,
            onShowComplete,
            onHideComplete,
        } = this.props;

        return (
            <Root
                className={className}
                onClick={this.handleClick}
                offsetLeft={offsetLeft}
                offsetTop={offsetTop}
                isHide={isHide}
                onAnimationEnd={onHideComplete}
            >
                <Image src={logo} isVisible={isShow} onTransitionEnd={onShowComplete} />
            </Root>
        );
    }
}

const Image = styled.img`
    width: 250px;

    opacity: ${({ isVisible }) => (isVisible ? 1 : 0)};

    will-change: opacity;
    transition: opacity 1s ease-in-out;

    ${mediaWidth.m} {
        width: 442px;
    };

    ${mediaWidth.l} {
        width: 516px;
    };

    ${mediaWidth.xl} {
        width: 615px;
    };
`;

const Root = styled.div`
    position: absolute;
    top: ${({ offsetTop }) => `${offsetTop + 302}px`};
    left: ${({ offsetLeft }) => `${offsetLeft + 55}px`};

    will-change: opacity, transform;
    animation-name: ${({ isHide }) => (isHide ? hideAnimation.name : 'none')};
    animation-duration: ${({ isHide }) => (isHide ? hideAnimation.duration : 0)};
    animation-timing-function: ${({ isHide }) => (isHide ? hideAnimation.timingFunction : 'unset')};
    animation-fill-mode: forwards;

    ${mediaWidth.m} {
        top: ${({ offsetTop }) => `${offsetTop + 480}px`};
        left: ${({ offsetLeft }) => `${offsetLeft + 163}px`};
    };

    ${mediaWidth.l} {
        top: ${({ offsetTop }) => `${offsetTop + 347}px`};
        left: ${({ offsetLeft }) => `${offsetLeft + 254}px`};
    };

    ${mediaWidth.xl} {
        top: ${({ offsetTop }) => `${offsetTop + 405}px`};
        left: ${({ offsetLeft }) => `${offsetLeft + 412}px`};
    };
`;
